/* eslint-disable func-names */
/*
 * This search request obj gets passed to the vcda module in ws-scripts
 * to make parallel request to each service
 */

export const getSearchRO = vehicleId => {
	return {
		media: {
			uuid: vehicleId,
			select: ['images', 'videos']
		},
		vehicle: {
			uuid: vehicleId
		}
	};
};

/*
 * Takes a URL and a map of URL parameters, and combines them into a full URL.
 */

export const buildUrlWithParams = (url, params = new Map()) => {
	if (!params.size) {
		return url;
	}
	const paramString = Array.from(params, keyValuePair =>
		keyValuePair.map(encodeURIComponent).join('=')
	).join('&');

	return `${url}?${paramString}`;
};

// Underscore's debounce function
export const debounce = function(func, wait, immediate) {
	let timeout;
	return function() {
		// eslint-disable-next-line one-var
		const context = this,
			args = arguments; // eslint-disable-line prefer-rest-params
		const later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		const callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};



// WEBPACK FOOTER //
// ./src/helpers/utility.js